export default __webpack_public_path__ + "static/media/export_icon.568931e8.svg";